import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-panel-start',
  styles: [
    ':host { align-self: center}'
  ],
  template: '<ng-content />'
})
export class PanelStartComponent {}
